/* global showInfoToast */
import React, { useState, useEffect, useContext } from "react";
import { getContactsList } from "../api/api";
import FooterBar from "./layout/FooterBar";
import FooterButton from "./tools/FooterButton";
import { SearchContext } from "./layout/SearchContext";

const Rubrica = (props) => {
  const [contactsList, setContactsList] = useState([]);
  const { searchTerm } = useContext(SearchContext);
  const companyID = props.userDetails?.Company?.[0]?.dataID || null;

  const loadContactsList = async () => {
    const response = await getContactsList(companyID);
    setContactsList(response?.data?.data?.getContactListing?.edges || []);
  };

  useEffect(() => {
    if(companyID) {
      loadContactsList();
    }
  }, [companyID]);

  const normalizedFilter = searchTerm.trim().toLowerCase();
  const filtered = contactsList.filter(edge => {
    const c = edge.node || {};
    if (!normalizedFilter) return true;
    return [c.firstName, c.lastName, c.description]
      .filter(Boolean)
      .join(" ")
      .toLowerCase()
      .includes(normalizedFilter);
  });

  // sort and group by initial (lastName first, fallback to firstName)
  const sorted = [...filtered].sort((a, b) => {
    const aNode = a.node || {};
    const bNode = b.node || {};
    const aLast = (aNode.lastName || "").toString().localeCompare((bNode.lastName || "").toString(), undefined, { sensitivity: 'base' });
    if (aLast !== 0) return aLast;
    return (aNode.firstName || "").toString().localeCompare((bNode.firstName || "").toString(), undefined, { sensitivity: 'base' });
  });

  const grouped = sorted.reduce((acc, edge) => {
    const c = edge.node || {};
    const name = (c.lastName || c.firstName || "").trim();
    const letter = name ? name[0].toUpperCase() : "#";
    if (!acc[letter]) acc[letter] = [];
    acc[letter].push(edge);
    return acc;
  }, {});

  let letters = Object.keys(grouped).sort((a, b) => {
    if (a === "#") return 1;
    if (b === "#") return -1;
    return a.localeCompare(b);
  });

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12 col-md-8 col-lg-7 col-xl-5">
          <div className="card">
            <div className="card-body">
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-start mb-3">
                <div>
                  {/* <a href="/account" className="btn btn-primary">Aggiungi contatto</a> */}
                </div>
              </div>

              {/* Mobile/card view */}
              <div className="d-block d-md-none">
                {letters.map((letter) => (
                  <div key={`group-${letter}`}>
                    <div className="alpha-sep font-weight-bold mt-3 mb-1">{letter}</div>
                    {grouped[letter].map((edge, idx) => {
                      const contact = edge.node || {};
                      return (
                        <div key={`${letter}-m-${idx}`} className="card mb-2">
                          <div className="card-body p-2 d-flex justify-content-between align-items-center">
                            <div>
                              <div className="font-weight-bold">{contact.lastName} {contact.firstName}</div>
                              {contact.description && (
                                <div className="text-muted small mb-1">{contact.description}</div>
                              )}
                              {contact.email && <div className="text-muted small">Email: {contact.email}</div>}
                              {contact.phone && <div className="text-muted small">Tel: {contact.phone.toString().split('.').join('')}</div>}
                            </div>
                            <div className="d-flex flex-column ml-2">
                              {contact.phone && (
                                <a href={`tel:${contact.phone.toString().split('.').join('')}`} className="btn btn-sm btn-outline-primary mb-1" aria-label="Chiama">
                                  <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>
                                    call
                                  </span>
                                </a>
                              )}
                              {contact.email && (
                                <a href={`mailto:${contact.email}`} className="btn btn-sm btn-outline-danger mb-1" aria-label="Email">
                                  <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>
                                    alternate_email
                                  </span>
                                </a>
                              )}
                              {contact.whatsapp && (
                                <a href={`https://wa.me/39${contact.whatsapp}`} target="_blank" className="btn btn-sm btn-outline-success" aria-label="Whatsapp">
                                  <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>
                                    chat_bubble
                                  </span>
                                </a>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <FooterBar 
        footerIcon={"person_book"} 
        footerTitle={`Rubrica`}
        footerButton={
          <FooterButton icon="add" title="Aggiungi contatto" action={() => showInfoToast("Disponibile nel prossimo aggiornamento")} />
        }
      />
    </div>
  );
};

export default Rubrica;